import { defineStore } from 'pinia'

import { useInstanceStore } from 'src/stores/instance.js'
import { useLocalConfigStore } from 'src/stores/local_config.js'
import { useSyncConfigStore } from 'src/stores/sync_config.js'

import {
  LOCAL_ONLY_KEYS,
  ROOT_CONFIG,
} from 'src/modules/default_config_state.js'

// the user's own value of a setting, or undefined: a temporary override,
// then this device's value (for device-only settings), then the synced one
const userValue = (k) => {
  const { tempStorage, prefsStorage: localPrefs } = useLocalConfigStore()
  const syncPrefs = useSyncConfigStore().prefsStorage
  return (
    tempStorage[k] ??
    (LOCAL_ONLY_KEYS.has(k) ? localPrefs[k] : undefined) ??
    syncPrefs.simple[k]
  )
}

// the instance's default of a setting, else the frontend's
const defaultValue = (k) => useInstanceStore().prefsStorage[k] ?? ROOT_CONFIG[k]

const allKeys = (valueFor) =>
  Object.fromEntries(Object.keys(ROOT_CONFIG).map((k) => [k, valueFor(k)]))

export const useMergedConfigStore = defineStore('merged_config', {
  getters: {
    mergedConfig: () => allKeys((k) => userValue(k) ?? defaultValue(k)),
    mergedConfigDefault: () => allKeys(defaultValue),
    // what the user set, for the settings backup
    mergedConfigWithoutDefaults: () => allKeys(userValue),
  },
})
